module.exports = __webpack_public_path__ + "img/4.bc159694.jpg";